import { createContext } from 'react'

// Only the receiving controller supplies this action; unrelated RF screens keep their own menu.
export const ReceivingNavigationContext = createContext<(() => void) | null>(null)
